import React, { useContext, useEffect } from 'react';
import axios from 'axios';
import { message } from 'antd';
import { ADD_TO_CART_API, GET_CART_BY_AGENT_ID, DELETE_FROM_CART_API, CLEAR_CART_BY_AGENT_ID, MODIFY_CART_QUANTITY_API } from '../API/paths';
import UserContext from './UserContext';
import usePersistentState from '../AdminPortal/hooks/usePersistentState';
import { BASE_URL } from '../Constants/EnvironmentVariableProvider';

export const CartContext = React.createContext({
  cart: [],
  addToCart: () => {},
  deleteItemCart: () => {},
  fetchCart: () => {},
  modifyQuantity: () =>{},
});

export const CartProvider = ({ children }) => {
  const [cart, setCart] = usePersistentState("cart", {
    initialValue: [],
    isSession: false
  });
  const { auth } = useContext(UserContext);
  // const setCartFromResponse = (cartData) => {
  //   //set cart data
  // }
  const fetchCart = async () => {
    try {
      if (!auth?.result?.ACAG_KeyID) return;
      const response = await axios.get(
        `${BASE_URL}/${GET_CART_BY_AGENT_ID + auth?.result?.ACAG_KeyID}`
      );
      if (response?.data?.success) {
        const cartItems = response.data.result.map(item => {
          const rewardsData = {...item.tbl_ARLR_Rewards};
          
          rewardsData.tbl_ARRV_Reward_Variants = rewardsData.tbl_ARRV_Reward_Variants
            .filter(variant => 
              variant.ARRV_Reward_Variant_KeyID !== 0 && 
              variant.ARRV_Title !== null
            )
            .map(variant => ({
              ...variant,
              status: variant.ARRV_Reward_Variant_KeyID === item.ARCT_Reward_Variant_ARRV_KeyID
            }));
  
          return {
            ...rewardsData,
            qty: item.ARCT_Quantity || 1,
            ARCT_KeyID: item.ARCT_KeyID,
            ARCT_Reward_ARLR_keyId: item.ARCT_Reward_ARLR_keyId,
            ARCT_Reward_Variant_ARRV_KeyID: item.ARCT_Reward_Variant_ARRV_KeyID,
            ARCT_Norm_Points: item.ARCT_Norm_Points,
            ARCT_Accumulative_Points: item.ARCT_Accumulative_Points,
            ARCT_Quantity: item.ARCT_Quantity
          };
        });
        setCart(cartItems);
      }
    } catch (error) {
      console.error('Error fetching cart:', error);
    }
  };
  useEffect(() => {
    if (auth?.result?.ACAG_KeyID) {
      fetchCart();
    }
    //eslint-disable-next-line
  }, [auth?.result?.ACAG_KeyID]);

  const addToCart = async (item, setModalopen) => {
    if (item === -1) {
        clearCart();
        setCart([]);
        return;
    }
    if (
        item?.ARLR_Redeemable_Quantity &&
        item?.Agent_Redeemed_Quantity >= item?.ARLR_Redeemable_Quantity
    ) {
        setModalopen(false);
        message.error("Maximum order quantity exceeded.");
        return false;
    }

    try {
        const selectedVariant = item.tbl_ARRV_Reward_Variants?.find(v => v.status);
        const cartData = {
            ARCT_Reward_ARLR_keyId: item.ARLR_KeyID,
            ARCT_Reward_Variant_ARRV_KeyID: selectedVariant?.ARRV_Reward_Variant_KeyID || null,
            ARCT_Quantity: 1,
            ARCT_Norm_Points: item.ARLR_Norm_Points,
            ARCT_Accumulative_Points: 0,
        };
        const existingItem = cart.find(cartItem => {
          const sameReward = cartItem.ARLR_KeyID === item.ARLR_KeyID;
          const sameVariant = selectedVariant 
              ? cartItem.ARCT_Reward_Variant_ARRV_KeyID === selectedVariant.ARRV_Reward_Variant_KeyID
              : cartItem.ARCT_Reward_Variant_ARRV_KeyID === null;
          return sameReward && sameVariant;
      });

        if (existingItem) {
          setModalopen(false);
          message.warning("This item is already in your cart");
          return;
        }

        const response = await axios.post(ADD_TO_CART_API, cartData);
        if (response?.data?.success) {
            await fetchCart();
            setModalopen(false);
            message.success("The reward has been added to your cart");
        }
    } catch (error) {
        message.error("Error adding to cart");
        return false;
    }
};

const deleteItemCart = async (index) => {
  const itemId = cart[index]?.ARCT_KeyID;
  try {
    const response = await axios.put(`${DELETE_FROM_CART_API}?Id=${itemId}`);
    if (response?.data?.success) {
      await fetchCart();
    }
  } catch (error) {
    message.error("Error removing from cart");
  }
};
const clearCart = async () => {
  try {
    const response = await axios.put(`${CLEAR_CART_BY_AGENT_ID}`);
    if (response?.data?.success) {
      await fetchCart();
    }
  } catch (error) {
    message.error("Error removing from cart");
  }
}

const modifyQuantity = async (item, newQuantity, onError) => {
  try {
    const selectedVariant = item.tbl_ARRV_Reward_Variants?.find(v => v.status);
    const cartData = {
      ARCT_Reward_ARLR_keyId: item.ARLR_KeyID,
      ARCT_Reward_Variant_ARRV_KeyID: selectedVariant?.ARRV_Reward_Variant_KeyID || null,
      ARCT_Quantity: newQuantity,
      ARCT_Norm_Points: item.ARLR_Norm_Points,
      ARCT_Accumulative_Points: item.ARLR_Norm_Points * newQuantity
    };

    const response = await axios.put(MODIFY_CART_QUANTITY_API, cartData);
    if (response?.data?.success) {
      await fetchCart();
      message.success("Quantity updated successfully");
      return true;
    } else {
      message.error(response?.data?.message || "Failed to update quantity");
      onError?.();
      return false;
    }
  } catch (error) {
    console.error('Error modifying quantity:', error);
    message.error("Error updating quantity");
    onError?.();
    return false;
  }
};

  return (
    <CartContext.Provider value={{ cart, addToCart, deleteItemCart, fetchCart, modifyQuantity}}>
      {children}
    </CartContext.Provider>
  );
};